import React from 'react';

/**
 * Tools Help Content
 */
const ToolsHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Tool Usage Analytics
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          The Tools page provides detailed analytics on how your agents use tools. Monitor performance, identify bottlenecks, and optimize tool configurations.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Summary Metrics
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Total Tools</span>: Number of unique tools used</p>
          <p>&#8226; <span className="font-medium">Total Invocations</span>: Combined tool call count</p>
          <p>&#8226; <span className="font-medium">Success Rate</span>: Percentage of successful calls</p>
          <p>&#8226; <span className="font-medium">P95 Latency</span>: 95th percentile response time</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Tool Details
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Expand any tool row to see detailed statistics:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Call Count</span>: Total invocations</p>
          <p>&#8226; <span className="font-medium">Success/Failure</span>: Breakdown by outcome</p>
          <p>&#8226; <span className="font-medium">Error Types</span>: Common failure reasons</p>
          <p>&#8226; <span className="font-medium">Latency Percentiles</span>: P50, P95, P99 response times</p>
          <p>&#8226; <span className="font-medium">Recent Errors</span>: Links to failed traces</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Latency Analysis
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Understanding latency percentiles:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">P50</span>: Median response time (typical performance)</p>
          <p>&#8226; <span className="font-medium">P95</span>: 95% of calls are faster than this</p>
          <p>&#8226; <span className="font-medium">P99</span>: Worst-case performance indicator</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Time Range
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Select different time ranges (1, 7, 30, or 90 days) to analyze tool performance over different periods and identify trends.
        </p>
      </div>

    </>
  );
};

export default ToolsHelp;
